export const EXP_CA_4057_SOCIAL_INTENTS_CHAT = 'ca-4057-social-intents-chat';
export const EXP_AP_46_TRUSTPILOT_CSAT = 'trustpilot_csat_testing';
export const EXP_CA_4863_INSTANT_CALLBACK_AVATARS = 'ca-4863-instant-callback-avatars';
export const EXP_HUB_2109_MESSAGE_CENTER_COPY = 'hub-2109-message-center-copy';
export const EXP_CA_5589_REFERRAL_PAGE = 'ca-5589-referral-page-experiment';
export const EXP_PAYROLL_TEAM_WIDGET_NAV = 'payroll-team-widget-nav';
